import { cssbuyFindsArticle } from "@/mocks/articles/cssbuy-finds";
import { cssbuyQcArticle } from "@/mocks/articles/cssbuy-qc";
import { cssbuySellersArticle } from "@/mocks/articles/cssbuy-sellers";
import { cssbuyTutorialsArticle } from "@/mocks/articles/cssbuy-tutorials";
import { cssbuyBeginnersArticle } from "@/mocks/articles/cssbuy-beginners";
import { cssbuyPaymentArticle } from "@/mocks/articles/cssbuy-payment";
import { cssbuyRefundArticle } from "@/mocks/articles/cssbuy-refund";
import { cssbuyAlternativesArticle } from "@/mocks/articles/cssbuy-alternatives";
import { cssbuyVsSuperbuyArticle } from "@/mocks/articles/cssbuy-vs-superbuy";
import { cssbuyTaobaoArticle } from "@/mocks/articles/cssbuy-taobao";

export type PillarArticleLang = {
  title: string;
  metaDescription: string;
  h1: string;
  summary: string;
  intro: string;
  sections: { h2: string; content: string }[];
  faq: { q: string; a: string }[];
  published: string;
  updated: string;
  readingTime: number;
  breadcrumb: string;
  related: { title: string; path: string }[];
};

export type PillarArticle = {
  path: string;
  image: string;
  en: PillarArticleLang;
  "pt-BR": PillarArticleLang;
  de: PillarArticleLang;
};

export const pillarArticles: Record<string, PillarArticle> = {
  "cssbuy-finds": cssbuyFindsArticle,
  "cssbuy-qc": cssbuyQcArticle,
  "cssbuy-sellers": cssbuySellersArticle,
  "cssbuy-tutorials": cssbuyTutorialsArticle,
  "cssbuy-beginners": cssbuyBeginnersArticle,
  "cssbuy-payment": cssbuyPaymentArticle,
  "cssbuy-refund": cssbuyRefundArticle,
  "cssbuy-alternatives": cssbuyAlternativesArticle,
  "cssbuy-vs-superbuy": cssbuyVsSuperbuyArticle,
  "cssbuy-taobao": cssbuyTaobaoArticle,
};

export const pillarArticleList = Object.values(pillarArticles);